import React from "react";
import { MessageCircle } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { buildWhatsAppLink } from "@/lib/contact";

export const WhatsAppFAB = () => {
  const { t } = useLang();
  const waLink = buildWhatsAppLink(t.whatsappMessage);
  return (
    <a
      href={waLink}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="WhatsApp"
      className="whatsapp-fab fixed right-3 md:right-8 z-40 h-11 w-11 md:h-14 md:w-14 rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(37,211,102,0.4)] flex items-center justify-center hover:scale-110 transition-transform duration-200"
    >
      <MessageCircle className="h-6 w-6" />
    </a>
  );
};
